
import api from '@/api';

const namespaced = true;

const state = {
  tabs: [
    { text: `Clients`, path: `/indeego-settings/clients` },
    { text: `Logs`, path: `/indeego-settings/logs` },
  ],
  clients: [],
};

const mutations = {
  SET_CLIENTS(state, clients) {
    state.clients = clients;
  },
};

const actions = {
  async fetchClients({ commit }) {
    const { data: clients } = await api.get(`/clients`);
    commit(`SET_CLIENTS`, clients);

    return clients;
  },
  async fetchClientUsersWithSpaces(store, clientId) {
    try {
      const { data: users } = await api.get(`/users/client/${clientId}/with-spaces`);

      return users || [];
    } catch (e) {
      return [];
    }
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
